import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChiefGuestReportLayer from "../components/ChiefGuestReportLayer";

const ChiefGuestReportPage = () => {
  return (
    <MasterLayout>
      <ChiefGuestReportLayer />
    </MasterLayout>
  );
};

export default ChiefGuestReportPage;
